import React from 'react'
import ReactDOM from 'react-dom'
import { library } from '@fortawesome/fontawesome-svg-core'
import reportWebVitals from './reportWebVitals'

import icons from './icons'
import Root from '../containers/Root'
import '../style/app.global.scss'
// import { crashReporter } from '../../shared';

if (process.env.NODE_ENV === 'production') {
    // Initialize reporter the sooner as possible
    // crashReporter.init();
}

// Import FA icons
library.add(...icons)

ReactDOM.render(
    <React.StrictMode>
        <Root />
    </React.StrictMode>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
